import EventHubMixin from '@/mixins/EventHub.js'
import SizesMixin from '@/mixins/Sizes.js'
import ScrollMixin from '@/mixins/Scroll'

export default
{
    name: 'app-grid',

    mixins:
    [
        EventHubMixin,
        SizesMixin,
        ScrollMixin
    ],

    data()
    {
        return {
            horizontals: [],
            verticals: [],
            isActive: false,
            parallax: 0,
            parallaxMultiplier: 4
        }
    },

    watch:
    {
        $route: function()
        {
            this.unfocusItem()
        }
    },

    created()
    {
        this.originalHorizontals = null
        this.originalVerticals = null

        this.scrollProgress = {}
        this.scrollProgress.value = 0
        this.scrollProgress.rounded = 0
        this.scrollProgress.bodyHeight = 800
    },

    mounted()
    {
        this.onResize()

        this.$eventHub.$on('grid.focusItem', this.focusItem)
        this.$eventHub.$on('grid.unfocusItem', this.unfocusItem)
        this.$eventHub.$on('main.pageEnter', () =>
        {
            this.scrollProgress.bodyHeight = this.$root.config.scrollHeightElement.offsetHeight
        })
    },

    methods:
    {
        onScroll()
        {
            this.updateScrollProgress()
        },

        onResize()
        {
            this.horizontals = []
            for(let i = 0; i < this.$root.grid.flooredCountX; i++)
            {
                this.horizontals.push(i * this.$root.grid.amplitude + this.$root.grid.offsetX)
            }

            this.verticals = []
            for(let i = 0; i < this.$root.grid.flooredCountY * this.parallaxMultiplier; i++)
            {
                this.verticals.push(i * this.$root.grid.amplitude + this.$root.grid.offsetY)
            }

            this.originalHorizontals = [...this.horizontals]
            this.originalVerticals = [...this.verticals]

            this.scrollProgress.bodyHeight = this.$root.config.scrollType === 'body' ? document.querySelector('#app').offsetHeight : document.body.offsetHeight
            this.updateScrollProgress()
        },

        updateScrollProgress()
        {
            // Mobile
            if(this.$root.config.platform.mobile)
            {
                return
            }

            this.scrollProgress.value = this.scroll.current / (this.scrollProgress.bodyHeight - this.sizes.height)
            this.scrollProgress.value = Math.min(Math.max(this.scrollProgress.value, 0), 1)

            if(isNaN(this.scrollProgress.value))
            {
                this.scrollProgress.value = 0
            }

            const rounded = Math.round(this.scrollProgress.value * 10000) / 10000

            if(rounded !== this.scrollProgress.rounded)
            {
                this.scrollProgress.rounded = rounded
                this.parallax = - this.scrollProgress.rounded * this.sizes.height * (this.parallaxMultiplier - 1)
            }
        },

        focusItem(_target)
        {
            this.isActive = true

            // Set up
            const bounding = _target.getBoundingClientRect()
            const horizontals = [...this.horizontals]
            const verticals = [...this.verticals]

            // Left
            let horizontalLeftKey = null
            let horizontalLeftDistance = Infinity
            for(let i = 0; i < horizontals.length; i++)
            {
                if(bounding.left + bounding.width * 0.5 > horizontals[i])
                {
                    const distance = Math.abs(bounding.left - horizontals[i])
                    if(distance < horizontalLeftDistance)
                    {
                        horizontalLeftDistance = distance
                        horizontalLeftKey = i
                    }
                }
            }

            // Right
            let horizontalRightKey = null
            let horizontalRightDistance = Infinity
            for(let i = horizontals.length - 1; i >= 0; i--)
            {
                if(bounding.left + bounding.width * 0.5 < horizontals[i])
                {
                    const distance = Math.abs(bounding.right - horizontals[i])
                    if(distance < horizontalRightDistance && i !== horizontalLeftKey)
                    {
                        horizontalRightDistance = distance
                        horizontalRightKey = i
                    }
                }
            }

            // Top
            let verticalTopKey = null
            let verticalTopDistance = Infinity
            for(let i = 0; i < verticals.length; i++)
            {
                if(bounding.top + bounding.height * 0.5 - this.parallax > verticals[i])
                {
                    const distance = Math.abs(bounding.top - verticals[i] - this.parallax)
                    if(distance < verticalTopDistance)
                    {
                        verticalTopDistance = distance
                        verticalTopKey = i
                    }
                }
            }

            // Bottom
            let verticalBottomKey = null
            let verticalBottomDistance = Infinity
            for(let i = verticals.length - 1; i >= 0; i--)
            {
                if(bounding.top + bounding.height * 0.5 - this.parallax < verticals[i])
                {
                    const distance = Math.abs(bounding.bottom - verticals[i] - this.parallax)
                    if(distance < verticalBottomDistance && i !== verticalTopKey)
                    {
                        verticalBottomDistance = distance
                        verticalBottomKey = i
                    }
                }
            }

            if(horizontalLeftKey !== null)
            {
                horizontals[horizontalLeftKey] = bounding.left
            }
            if(horizontalRightKey !== null)
            {
                horizontals[horizontalRightKey] = bounding.right
            }
            if(verticalTopKey !== null)
            {
                verticals[verticalTopKey] = bounding.top - this.parallax
            }
            if(verticalBottomKey !== null)
            {
                verticals[verticalBottomKey] = bounding.bottom - this.parallax
            }

            this.horizontals = horizontals
            this.verticals = verticals
        },

        unfocusItem()
        {
            this.isActive = false

            this.horizontals = this.originalHorizontals
            this.verticals = this.originalVerticals
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-grid/script.js